export default __webpack_public_path__ + "static/ifeat_thumbnail-db5d44a4285535dc4131df02b618561a.png";